<template>
  <div class="add-pay-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="680px"
      top="20px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-container class="flex just-center">
        <el-form
          ref="form"
          :model="params"
          :rules="rules"
          label-width="180px"
          label-position="right"
        >
          <el-form-item label="关键词：" prop="name">
            <el-input v-model="params.word" placeholder="请输入" maxlength="30"  size="medium"></el-input>
          </el-form-item>
          <el-form-item label="次数：" prop="desc">
            <el-input v-model.number="params.count" placeholder="请输入" maxlength="30"  size="medium"></el-input>
            <p class="fz12 red">用于排序：大-->小</p>
          </el-form-item>
          <el-form-item>
            <el-button @click="handleClose" size="small">取 消</el-button>
            <el-button
                type="primary"
                @click="submitForm('form')"
                :loading="flag"
                size="small"
            >确 认</el-button
            >
          </el-form-item>
        </el-form>
      </el-container>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api/hottag";

export default {
  data() {
    return {
      title:"",
      flag:false,
      dialogVisible:false,
      params: {
        id: "",
        word: "",
        count: 0,
      },
      rules: {
        word: [{ required: true, message: "请输入关键词", trigger: "blur" }],
      },
    };
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.type === "add") {
            this.handleSave();
          } else {
            this.handleEdit();
          }
        } else {
          return false;
        }
      });
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        id: "",
        word: '',
        count: 0
      };
      this.$refs["form"].resetFields();
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.type = type;
      this.dialogVisible = true;
      if (type === "edit") {
        this.title = "编辑热搜词";
        this.params.id = data.id;
        this.params.word = data.word;
        this.params.count = data.count;
        this.$forceUpdate();
      } else {
        this.title = "新增热搜词";
        this.params = {
          id: "",
          word: '',
          count: 0
        }
      }
    },
    // 新增
    handleSave() {
      API.save(this.params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.$emit("callback");
          } else {
            this.$message.error("添加失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 编辑
    handleEdit() {
      let form = Object.assign(this.params);
      API.update(form)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功",
              type: "success",
            });
            this.$emit("callback");
          } else {
            this.$message.error("编辑失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
  },
};
</script>

<style lang="scss">
.add-pay-box {
  .el-input {
    width: 240px;
  }
  .form-flex-box {
    display: flex;
    .el-form-item {
      flex: 1;
    }
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
